import { Tab } from 'react-tabs'
import Flex from 'typescript-styled-flex'
import styled, { ITheme } from '../../../theme'
import is from 'typescript-styled-is'

const BBTab = styled(Flex.withComponent(Tab) as any)<ITabProps>`
  cursor: pointer;
  width: 100%;
  padding-bottom: 12px;
  font-weight: 500;
  min-width: 0;
  ${is('disabled')`
    opacity: 0.5;
    cursor: not-allowed;
  `}
  &.react-tabs__tab--selected {
    border-bottom: 2px solid ${(props: ITheme) => props.theme.colors.primary};
    color: ${(props: ITheme) => props.theme.colors.primary};
    outline: none;

    & > div > img {
      filter: invert(43%) sepia(44%) saturate(4709%) hue-rotate(122deg)
        brightness(93%) contrast(101%);
    }
    & > div > svg {
      filter: invert(43%) sepia(44%) saturate(4709%) hue-rotate(122deg)
        brightness(93%) contrast(101%);
    }
    & > span > img {
      filter: invert(43%) sepia(44%) saturate(4709%) hue-rotate(122deg)
        brightness(93%) contrast(101%);
    }
    & > span > svg {
      filter: invert(43%) sepia(44%) saturate(4709%) hue-rotate(122deg)
        brightness(93%) contrast(101%);
    }
  }
  & > span {
    margin: 0px auto;
  }
  & > div > img {
    filter: invert(41%) sepia(6%) saturate(212%) hue-rotate(187deg)
      brightness(97%) contrast(85%);
  }
  & > span > img {
    filter: invert(41%) sepia(6%) saturate(212%) hue-rotate(187deg)
      brightness(97%) contrast(85%);
  }
`

export default BBTab

export interface ITabProps {
  count?: number
  disabled?: boolean
}
